module.exports = __webpack_public_path__ + "img/index_jije.56e896f9.png";